module.exports = __webpack_public_path__ + "img/stripe_logo.757ee22d.png";